import {AdvancedFilter} from "@/poster-gallery/classes/advanced-filters/advanced-filter";
import {DisplaySizeFilter} from "@/poster-gallery/classes/display-size-filter";
import {EVENT_UPDATE_SEARCH_FIELD, SearchTerm} from "@/poster-gallery/classes/search-term";
import {PosterGalleryFilters} from "@/poster-gallery/classes/poster-gallery-filters";
import {AdvancedFilterFactory} from "@/poster-gallery/classes/advanced-filters/advanced-filter-factory";
import '@/poster-gallery/components/sizes-sidebar';
import {SafeSearchFilter} from "@/poster-gallery/classes/safe-search-filter";
import {toggleSidebarWidth} from "@/poster-gallery/components/sizes-sidebar";
import {DesignStyleFilter} from "@/poster-gallery/classes/advanced-filters/design-style-filter.js";
import {initPosterGalleryObj} from "@/poster-gallery/components/init-poster-gallery-slice.js";
import {initGalleryHandlers, initGalleryPage, updateEmbeddedUrls} from "@/poster-gallery/components/init-poster-gallery-page.js";

/**
 * This file contains all code to handle dynamic refreshing of the gallery
 * based on the user's chosen filters
 */
const galleryFiltersSelector = '.js-gallery-filters',
    toggleFiltersButtonSelector = '.js-toggle-gallery-filters',
    toggleFilterOptionsDropdownButtonSelector = '.js-toggle-filter-options-dropdown',
    filterOptionsDropdownSelector = '.js-filter-type-options-container',
    filterTypeOptionSelector = '.js-filter-type-option',
    displaySizesSelector = '.js-size-href',
    showDisplaySubsizesSelector = '.js-show-display-subsizes',
    toggleSafeSearchSelector = '.js-safe-content-toggle',
    USER_HAS_CLOSED_AI_CHAT_BANNER_CACHE_KEY = 'user_has_closed_ai_chat_banner',
    /**
     * @var {jQuery}
     */
    pageGrid = $('.js-page-grid'),
    /**
     * @var {jQuery}
     */
    galleryContentContainer = $('.js-gallery-content-container'),
    /**
     * @var {jQuery}
     */
    galleryToggle = $('.js-gallery-type-toggle'),
    gridMasonrySelector = '.js-grid-masonry',
    visibleGridMasonrySelector = `${gridMasonrySelector}:visible`,
    subcategoriesSelector = '.subcategories-grid .js-subcategory-preview-item',
    suggestedCategoriesSelector = '.parent-category-search-results-list .category-suggestion-link',
    subfilterCarouselSelector = '.js-subfilter-carousel',
    emptyStateContainerSelector = '.js-poster-gallery-empty-state-container-list-item',
    emailGalleryToggleSelector = '.js-gallery-toggle-button.js-emails',
    safeSearchDisableSelectorForNotification = '.js-disable-safe-search',
    safeSearchNotificationContainerSelector = '.js-safe-search-notification-container',
    mobileSafeSearchNotificationContainerSelector = '.js-safe-search-notification-container-mobile',
    closeSafeSearchNotificationSelector = '.js-close-safe-search-notification',
    closeEventsAnnouncementBannerSelector = '.js-close-events-banner',
    eventsBannerCreateEventButtonSelector = '.js-event-banner-create',
    eventsAnnouncementBannerSelector = '.js-events-banner-container',
    aiChatBannerSelector = '.js-gallery-ai-chat-banner',
    closeAIChatBannerSelector = '.js-close-ai-chat-banner',
    aiChatBannerCTASelector = '.js-ai-chat-banner-cta',
    createWithAi = '.js-create-using-ai',
    createWithAiChat = '.js-create-with-ai-chat';

const EVENT_REFRESH_POSTER_GRID = 'poster-grid:refresh',
    EVENT_GALLERY_FILTER_CHANGED = 'gallery-filter-changed',
    EVENT_CATEGORY_SELECTED = 'category-selected',
    ID_MOBILE_FILTER_DIALOG = 'open-gallery-filters',
    SAFE_SEARCH_PREFERENCE_COOKIE = 'pmwssp',
    SUBCATEGORY_CAROUSEL_TYPE = 'subcategory',
    SAFE_SEARCH_EXCEPTION_EVENT_NAME = 'HighPercentageSafeSearchTerms',
    DESIGN_GALLERY_NO_SEARCH_RESULTS_EVENT_NAME = 'DesignGallery_NoSearchResult',
    GALLEY_AI_CHAT_BANNER_CLICK_GA4_EVENT = 'AI_Create_Banner_Click',
    modalBackAction = new ModalTopAction(window.i18next.t('pmwjs_back'), 'icon-arrow-left', mobileModalBackButtonAction, 'js-back-breadcrumb');

initPosterGalleryObj();

if (PMW.hideForStudent()) {
    PMW.redirectForStudentUserIfNeeded();
}

if (PMW.posterGallery.isDynamicGalleryPage()) {
    $(initDynamicGalleryHandlers)
}

function initDynamicGalleryHandlers() {
    const doc = $(document);
    initPosterGalleryFieldsInPosterGalleryObject();
    initGalleryPage();

    PMW.onClick(doc, toggleSafeSearchSelector, toggleSafeSearch);
    PMW.onClick(doc, toggleFiltersButtonSelector, toggleFiltersVisibility);
    PMW.onClick(doc, '.js-clear-filter-btn', onClearFilter);
    PMW.onClick(doc, toggleFilterOptionsDropdownButtonSelector, toggleFilterOptionsDropdownVisibility);
    PMW.onClick(doc, filterTypeOptionSelector, onChooseFilterTypeOption);
    PMW.onClick(doc, displaySizesSelector, onClickDisplaySize);
    PMW.onClick(pageGrid, subcategoriesSelector, onClickSubcategory);
    PMW.onClick(doc, '.js-show-display-size-options', onClickDisplaySizeDropdown);
    PMW.onClick(doc, toggleFilterOptionsDropdownButtonSelector, onClickMobileGalleryFilterType);
    PMW.onClick(doc, suggestedCategoriesSelector, onClickSuggestedCategories);
    PMW.onClick(doc, safeSearchDisableSelectorForNotification, onDisableSafeSearchFromNotificationClick);
    PMW.onClick(doc, closeSafeSearchNotificationSelector, hideSafeSearchNotification);
    PMW.onClick(doc, closeEventsAnnouncementBannerSelector, closeEventsBanner);
    PMW.onClick(doc, closeAIChatBannerSelector, closeAIChatBanner);
    PMW.onClick(doc, eventsBannerCreateEventButtonSelector, onClickCreateEventButton);
    PMW.onClick(doc, aiChatBannerCTASelector, onClickAIChatCTA);
    PMW.onClick(doc, createWithAi, PMW.unifiedGallery.onClickCreateUsingAI);
    PMW.onClick(doc, createWithAiChat, PMW.unifiedGallery.onClickCreateWithAiChat);
    $('.js-form-search-form').on('submit', onSubmitSearchForm);

    document.addEventListener(EVENT_CATEGORY_SELECTED, handleSubcategoryOptionClickedFromEvent);
    document.addEventListener(EVENT_REFRESH_POSTER_GRID, onTemplateGalleryRefresh);
    document.addEventListener(EVENT_GALLERY_FILTER_CHANGED, onGalleryFilterChange);
    window.addEventListener('popstate', onUrlPopStateChange);

    hideSafeSearchOptionForStudent();
    PMW.posterGallery.posterGalleryFilters.updateViewOnPageLoad(); // updates the view for selected display subsizes, and updates content type / motion filters
    const currentUrl = PMW.posterGallery.posterGalleryFilters.safeSearchFilter.updateUrl(window.location.href);
    window.history.replaceState(PMW.posterGallery.posterGalleryFilters.getPopStateObj(), '', currentUrl);

    if (isEmptyState()) {
        initEmptyState();
    }
    toggleAIChatBannerVisibility();
    doGa4Tracking();
    void initBannerForSafeSearchException();
}

function initPosterGalleryFieldsInPosterGalleryObject() {
    PMW.posterGallery.wasRequestRedirected = false;
    PMW.posterGallery.isMobileModalOpen = false;
    PMW.posterGallery.posterGalleryFilters = PosterGalleryFilters.fromPageHtml();
    PMW.posterGallery.posterGalleryFilters.searchTermFilter = SearchTerm.fromPageURL();

    PMW.posterGallery.updateActiveFilterIcon = function () {
        const posterGalleryFilters = PMW.posterGallery.getPosterGalleryFiltersForUpdate(),
            numActiveGalleryFilters = posterGalleryFilters.getCountOfActiveAdvancedFilters(),
            toggleFiltersButton = $(toggleFiltersButtonSelector);

        if (toggleFiltersButton.hasClass('-active') || numActiveGalleryFilters === 0) {
            toggleFiltersButton.removeClass('-filters-active');
            return;
        }
        toggleFiltersButton.attr('data-num-active-filters', numActiveGalleryFilters);
        toggleFiltersButton.addClass('-filters-active');
    };

    /**
     * @return {PosterGalleryFilters}
     */
    PMW.posterGallery.getPosterGalleryFiltersForUpdate = function () {
        return PMW.posterGallery.isMobileModalOpen ? PMW.posterGallery.posterGalleryFiltersForMobileModal : PMW.posterGallery.posterGalleryFilters;
    };

    PMW.posterGallery.removeSubsizesCarousel = function () {
        $('#subsizes-container').remove();
        galleryContentContainer.removeClass('-has-subcategories-carousel');
    };

    /**
     * @return {boolean|null}
     */
    PMW.posterGallery.getSafeSearchPreferenceFromCookie = function () {
        let safeSearchPreference = PMW.util.readCookie(SAFE_SEARCH_PREFERENCE_COOKIE);

        if (safeSearchPreference === null) {
            return null;
        }
        safeSearchPreference = safeSearchPreference.trim();

        if (safeSearchPreference === '' || Number.isNaN(Number(safeSearchPreference))) {
            return null;
        }
        return Number(safeSearchPreference) === 1;
    };

    /**
     * @return {boolean}
     */
    PMW.posterGallery.isSafeSearchPreferenceSet = function () {
        return PMW.posterGallery.getSafeSearchPreferenceFromCookie() !== null
    };

    /**
     * @param {boolean} isFlyoutVisible
     */
    PMW.posterGallery.adjustSafeSearchNotificationPosition = function (isFlyoutVisible) {
        const mobileSafeSearchNotification = $(mobileSafeSearchNotificationContainerSelector);
        mobileSafeSearchNotification.toggleClass('align-left', isFlyoutVisible);
        updateSafeSearchNotificationText(isFlyoutVisible);
    };
}

function hideSafeSearchOptionForStudent() {
    if (PMW.isStudent()) {
        PMW.posterGallery.posterGalleryFilters.safeSearchFilter.disableForStudent();
    }
}

async function initBannerForSafeSearchException() {
    if (!PMW.posterGallery.getPosterGalleryFiltersForUpdate().getCurrentSafeSearchStatus() || PMW.isStudent()) {
        return;
    }
    const grid = getGridMasonry();

    if (grid.attr('data-is-invalid') === '1') {
        return; // do not show the notification for urls with soft 404's
    }
    const currentPagePathAndParams = PMW.util.getPagePathAndSearchParamsFromUrl(pageGrid.attr('data-url'));
    let result;

    try {
        result = await PMW.readLocal('posters/getNotificationForSafeSearchException' + currentPagePathAndParams);
    } catch (Error) {
        return;
    }

    if (Number(result.isRequired) === 0) {
        return;
    }
    trackSafeSearchExceptionSearchTerm();
    $(safeSearchNotificationContainerSelector).removeClass('_hidden');
}

function trackSafeSearchExceptionSearchTerm() {
    if (!PMW.posterGallery.isSearchPage()) {
        return;
    }
    const searchTerm = PMW.posterGallery.posterGalleryFilters.searchTermFilter.searchTerm;

    if (searchTerm !== '') {
        PMW.gtm.trackGA4CustomEvent(SAFE_SEARCH_EXCEPTION_EVENT_NAME, {searchTerm});
    }
}

/**
 * @type {function[]}
 */
let modalBackButtonCallbacks = [];

/**
 * @param {Object} popStateEvent
 */
function onUrlPopStateChange(popStateEvent) {
    if (isPopStateInfoValid(popStateEvent)) {
        if (PMW.posterGallery.isMobileModalOpen) {
            onCloseModalByCloseButton();
        }
        toggleAllSizeOptionVisibility();
        PMW.posterGallery.posterGalleryFilters.updateFiltersFromPopState(popStateEvent.state);
        refreshGridForBrowserHistoryAPI(window.location.href);
    }
}

/**
 * @param {Object} popStateEvent
 * @return {boolean}
 */
function isPopStateInfoValid(popStateEvent) {
    return popStateEvent && typeof popStateEvent.state === 'object' && popStateEvent.state !== null;
}

/**
 * @param {Event} e
 */
function onSubmitSearchForm(e) {
    syncSearchFieldsOnPage($(this));
    e.preventDefault();
    e.stopPropagation();

    if (SearchTerm.readSearchTerm() === '') {
        return;
    }
    const searchTerm = SearchTerm.fromPageHtml();

    document.dispatchEvent(new CustomEvent(EVENT_GALLERY_FILTER_CHANGED, {
        detail: {
            filter: searchTerm,
            type: SearchTerm.filterType,
        }
    }));
}

/**
 * @param {jQuery} searchFieldContainer
 */
function syncSearchFieldsOnPage(searchFieldContainer) {
    const submittedSearchText = searchFieldContainer.find('.js-search-field-input').val();
    $('.js-search-field-input').val(submittedSearchText);
}

/**
 * @param {string} url
 */
function refreshGridForBrowserHistoryAPI(url) {
    document.dispatchEvent(new CustomEvent(EVENT_REFRESH_POSTER_GRID, {
        detail: {
            redirectUrl: url,
            isRefreshThroughHistoryAPI: true,
        }
    }));
}

function toggleFiltersVisibility() {
    const cta = $(this);
    $('.js-search-field-input').blur();

    if (cta.attr('data-is-mobile-cta') === '1') {
        openMobileFiltersModal();
        return;
    }
    $(toggleFiltersButtonSelector).toggleClass('-active');
    $(galleryFiltersSelector).toggleClass('-show-gallery-filters').one(PMW.util.transitionEndEvents, PMW.unifiedGallery.adjustSidebarVerticalMeasurements);
    PMW.posterGallery.updateActiveFilterIcon();
}

function applyMobileGalleryFilters() {
    PMW.posterGallery.isMobileModalOpen = false;

    if (PMW.posterGallery.urlForMobileModal === window.location.href) {
        closeFiltersDialog();
        return;
    }
    PMW.posterGallery.posterGalleryFilters = PMW.posterGallery.posterGalleryFiltersForMobileModal;

    document.dispatchEvent(new CustomEvent(EVENT_REFRESH_POSTER_GRID, {
        detail: {
            redirectUrl: PMW.posterGallery.urlForMobileModal,
            isRefreshThroughHistoryAPI: false,
        }
    }));
    closeFiltersDialog();
}

function onCloseModalByOutsideClick() {
    PMW.posterGallery.isMobileModalOpen = false;
    PMW.posterGallery.posterGalleryFilters.updateView();
    handleModalClosingInsideGalleryDialog();
}

function onCloseModalByCloseButton() {
    PMW.posterGallery.isMobileModalOpen = false;
    PMW.posterGallery.posterGalleryFilters.updateView();
    closeFiltersDialog();
}

function openMobileFiltersModal() {
    let btn = {},
        dialog;

    btn[window.i18next.t('pmwjs_apply_gallery_filters')] = {
        classes: '-fullwidth _unmargin disabled js-apply-filters',
        ch: applyMobileGalleryFilters
    };
    dialog = PMW.openModalDialog(ID_MOBILE_FILTER_DIALOG, window.i18next.t('pmwjs_filters'), btn, true, '-modal-500 -full-height -capped -fullwidth-footer');
    handleModalOpeningInsideGalleryDialog();
    PMW.bindModalCloseEvents(ID_MOBILE_FILTER_DIALOG, onCloseModalByOutsideClick);
    PMW.load(dialog.find('.content'), PMW.util.site_url('poster/galleryFiltersMobileDialog'), {}, onOpenMobileFilterDialog);
}

function onClickDisplaySizeDropdown() {
    const displaySizePanel = $('.js-display-size-panel');
    showMobileFiltersPanel(displaySizePanel);
}

async function onOpenMobileFilterDialog() {
    PMW.posterGallery.posterGalleryFiltersForMobileModal = PosterGalleryFilters.copyGalleryFilters(PMW.posterGallery.posterGalleryFilters);
    PMW.posterGallery.urlForMobileModal = window.location.href;
    modalBackButtonCallbacks = [];
    PMW.posterGallery.isMobileModalOpen = true;
    toggleAllSizeOptionVisibility();

    /**
     * @var {jQuery}
     */
    const filtersModal = $(`#${ID_MOBILE_FILTER_DIALOG}`);
    PMW.onClick(filtersModal.find('.close'), null, onCloseModalByCloseButton);
    filtersModal.find('.js-apply-filters').removeClass('disabled');

    filtersModal.find('.js-select-filters').attr('data-modal-title', window.i18next.t('pmwjs_filters'));
    PMW.posterGallery.posterGalleryFiltersForMobileModal.updateView();
}

function onClickMobileGalleryFilterType() {
    const showFilterOptionsButton = $(this),
        filterTypeButton = showFilterOptionsButton.closest('.js-filter-type');

    if (!AdvancedFilter.shouldShowFilterTypeOptions(filterTypeButton)) {
        return;
    }
    const filterType = showFilterOptionsButton.attr('data-filter-type'),
        filterOptionsPanel = $(`.js-advanced-filters-panel.js-${filterType}-options`);
    showMobileFiltersPanel(filterOptionsPanel);
}

/**
 * Following the undo action chain ensures the panels flow correctly into the main panel
 */
function returnToMobileModalMainPanel() {
    while (modalBackButtonCallbacks.length > 0) {
        mobileModalBackButtonAction();
    }
}

/**
 * @param {jQuery} mobileFilterPanel
 * @param {boolean} isUndoAction
 */
function showMobileFiltersPanel(mobileFilterPanel, isUndoAction = false) {
    const allPanels = $('.js-sliding-panel'),
        /**
         * @var {jQuery}
         */
        filtersModal = $(`#${ID_MOBILE_FILTER_DIALOG}`),
        currentActivePanel = allPanels.filter('.-in'),
        isTargetPanelMainPanel = mobileFilterPanel.hasClass('js-select-filters');
    PMW.updateModalDialogTitle(filtersModal, mobileFilterPanel.attr('data-modal-title'), true);

    if (isTargetPanelMainPanel) {
        filtersModal.find('.footer').fadeIn(200);
    } else {
        filtersModal.find('.footer').fadeOut(200);
    }
    currentActivePanel.toggleClass('-out', !isUndoAction);
    currentActivePanel.removeClass('-in');
    mobileFilterPanel.addClass('-in').removeClass('-out');

    if (isTargetPanelMainPanel) {
        modalBackButtonCallbacks = [];
        PMW.removeBackButtonToModal(filtersModal);
        return;
    }

    if (!isUndoAction) {
        addBackButtonToModal(currentActivePanel, filtersModal);
    }
}

/**
 * @param {jQuery} mobileFilterPanel
 * @param {boolean} isUndoAction
 */
PMW.posterGallery.showMobileFiltersPanel = showMobileFiltersPanel;

/**
 * @param {jQuery} currentActivePanel
 * @param {jQuery} filtersModal
 */
function addBackButtonToModal(currentActivePanel, filtersModal) {
    modalBackButtonCallbacks.push(showMobileFiltersPanel.bind(this, currentActivePanel, true));
    PMW.addBackButtonToModal(filtersModal, modalBackAction);
}

function mobileModalBackButtonAction() {
    const undoFn = modalBackButtonCallbacks.pop();
    undoFn();
}

/**
 * @param {Event} e
 */
function toggleFilterOptionsDropdownVisibility(e) {
    e.stopPropagation();
    const currentDropdown = $(this).siblings(filterOptionsDropdownSelector),
        filterTypeButton = $(this).closest('.js-filter-type');

    if (!AdvancedFilter.shouldShowFilterTypeOptions(filterTypeButton)) {
        closeAllFilterDropdowns();
        return;
    }
    currentDropdown.toggleClass('-show-dropdown');
    if (currentDropdown.hasClass('-show-dropdown')) {
        $(document)
            .off(`${PMW.click}.toggle-filter-options-dropdown`)
            .one(`${PMW.click}.toggle-filter-options-dropdown`, null, null, closeAllFilterDropdowns);

        if (currentDropdown.hasClass(DesignStyleFilter.getFilterOptionsDropdownClassname())) {
            adjustDesignStyleFilterOptionsHeight(currentDropdown);
        }
    }
    closeAllFilterDropdownsExcept(currentDropdown);
}

function adjustDesignStyleFilterOptionsHeight(designStyleFiltersDropdown) {
    const isInFlyout = designStyleFiltersDropdown.closest('.js-page-top-search-field').length > 0;
    let offsetTop;

    if (isInFlyout) {
        offsetTop = $('.js-page-top-search-field').outerHeight();
    } else {
        offsetTop = designStyleFiltersDropdown.offset().top - window.scrollY;
    }

    if (offsetTop < 0) {
        offsetTop = 0;
    }
    const viewportHeight = ($(document.body)).outerHeight(),
        dropdownMaxHeight = (viewportHeight - offsetTop) * 0.8,
        dropdownMinHeight = 300;

    const adjustHeightToPartiallyShowNextOption = (height) => {
        const filterOptionHeight = 48,
            filterOptionMargin = 8,
            filterOptionTotalHeight = filterOptionHeight + filterOptionMargin, // each option occupies 56px total (48px height + 8px margin)
            numFilterOptionsVisible = height / filterOptionTotalHeight,
            numOptionsFullyVisible = Math.floor(numFilterOptionsVisible);
        return (numOptionsFullyVisible + 1) * filterOptionTotalHeight - filterOptionHeight * 0.4; // show 60% of the next option so users know that they can scroll
    };
    designStyleFiltersDropdown.css({
        maxHeight: `${adjustHeightToPartiallyShowNextOption(dropdownMaxHeight)}px`,
        minHeight: `${adjustHeightToPartiallyShowNextOption(dropdownMinHeight)}px`,
    });
}

/**
 * @param {jQuery} dropdownToNotClose
 */
function closeAllFilterDropdownsExcept(dropdownToNotClose) {
    /**
     * @var {jQuery}
     */
    const allDropdowns = $(filterOptionsDropdownSelector),
        dropdownsToClose = allDropdowns.not(dropdownToNotClose);
    dropdownsToClose.removeClass('-show-dropdown');
}

function closeAllFilterDropdowns() {
    /**
     * @var {jQuery}
     */
    const dropdownsToClose = $(filterOptionsDropdownSelector);
    dropdownsToClose.removeClass('-show-dropdown');
}

function onChooseFilterTypeOption() {
    const chosenFilterTypeOption = $(this);

    if (AdvancedFilter.isChosenFilterOptionActive(chosenFilterTypeOption)) {
        return;
    }
    const advancedFilter = AdvancedFilterFactory.fromFilterOption(chosenFilterTypeOption);
    document.dispatchEvent(new CustomEvent(EVENT_GALLERY_FILTER_CHANGED, {
        detail: {
            filter: advancedFilter,
            type: AdvancedFilter.advancedFiltersKey,
            advancedFiltersArrayKey: advancedFilter.advancedFiltersArrayKey,
        }
    }));
}

async function toggleSafeSearch() {
    const currentSafeSearchStatus = PMW.posterGallery.getPosterGalleryFiltersForUpdate().getCurrentSafeSearchStatus(),
        newSafeSearchStatus = !currentSafeSearchStatus,
        toggledSafeSearch = new SafeSearchFilter(newSafeSearchStatus);

    setUserSafeSearchPreferenceCookie(newSafeSearchStatus);
    document.dispatchEvent(new CustomEvent(EVENT_GALLERY_FILTER_CHANGED, {
        detail: {
            filter: toggledSafeSearch,
            type: SafeSearchFilter.filterType,
        }
    }));
    return recordUserSafeSearchPreference(newSafeSearchStatus);
}

/**
 * @param {Event} e
 */
function onClearFilter(e) {
    e.stopPropagation();
    const filterClearButton = $(this),
        filterTypeButton = filterClearButton.closest('.js-filter-type'),
        filterType = filterTypeButton.attr('data-filter-type'),
        allFilterOption = $(`.js-${filterType}-options .js-filter-type-option[data-filter-option=${AdvancedFilter.allFilterOption}]`),
        advancedFilter = AdvancedFilterFactory.fromFilterOption(allFilterOption);

    closeAllFilterDropdowns();
    document.dispatchEvent(new CustomEvent(EVENT_GALLERY_FILTER_CHANGED, {
        detail: {
            filter: advancedFilter,
            type: AdvancedFilter.advancedFiltersKey,
            advancedFiltersArrayKey: advancedFilter.advancedFiltersArrayKey,
        }
    }));
}

/**
 * @param {Event} e
 */
function onClickDisplaySize(e) {
    e.preventDefault();
    e.stopPropagation();
    const displaySize = $(this);

    if (displaySize.closest('.js-size-filter').hasClass('-has-subsizes')) {
        openDisplaySubsizesListForDisplaySize(displaySize);
        return;
    }

    if (DisplaySizeFilter.isChosenDisplaySizeActive(displaySize)) {
        if (PMW.posterGallery.isMobileModalOpen) {
            returnToMobileModalMainPanel();
        }
        return;
    }
    const displaySizeFilter = DisplaySizeFilter.fromFilterOption(displaySize);
    document.dispatchEvent(new CustomEvent(EVENT_GALLERY_FILTER_CHANGED, {
        detail: {
            filter: displaySizeFilter,
            type: DisplaySizeFilter.filterType,
            isClickManuallyTriggered: (e.detail) ? Boolean(e.detail.isClickManuallyTriggered) : false
        }
    }));
}

/**
 * If a size with subsizes is selected from the sidebar
 * we open the subsizes list for the parent display size
 *
 * @param {jQuery} displaySize
 */
function openDisplaySubsizesListForDisplaySize(displaySize) {
    const displaySizeOptionContainer = displaySize.closest('.js-size-filter');

    if (!displaySizeOptionContainer.hasClass('-subsize')) {
        displaySizeOptionContainer.find(showDisplaySubsizesSelector).trigger(PMW.click);
    }
}

function onClickSuggestedCategories() {
    const subcategoryOption = $(this);

    $('.parent-category-search-results-list').addClass('_hidden');

    const newSearchTermFilter = new SearchTerm('');
    PMW.posterGallery.getPosterGalleryFiltersForUpdate().searchTermFilter.handleUpdatedFilter(newSearchTermFilter);
    handleSubcategoryOptionClicked(subcategoryOption.attr('href'));
}

function onClickSubcategory() {
    const subcategoryOption = $(this);
    subcategoryOption.addClass('-loading');
    subcategoryOption.siblings('.js-subcategory-preview-item').addClass('-disabled').removeClass('-active');
    handleSubcategoryOptionClicked(subcategoryOption.find('a').attr('href'));
}

function handleSubcategoryOptionClickedFromEvent(e) {
    const newSearchTermFilter = new SearchTerm('');
    PMW.posterGallery.getPosterGalleryFiltersForUpdate().searchTermFilter.handleUpdatedFilter(newSearchTermFilter);
    handleSubcategoryOptionClicked(e.detail.url);
}

/**
 * Add the appropriate content type segment to the url and update the grid.
 *
 * @param {string} url
 */
function handleSubcategoryOptionClicked(url) {
    url = PMW.posterGallery.posterGalleryFilters.updateUrlForAdvancedFilters(new URL(url), true).toString();

    document.dispatchEvent(new CustomEvent(EVENT_REFRESH_POSTER_GRID, {
        detail: {
            redirectUrl: url,
            isRefreshThroughHistoryAPI: false,
        }
    }));
}

/**
 * @param {Event} e
 * @return {Promise<void>}
 */
async function onDisableSafeSearchFromNotificationClick(e) {
    e.preventDefault();
    $(`${toggleFiltersButtonSelector}:visible`).not('.-phone').not('.-active').trigger(PMW.click);
    hideSafeSearchNotification();
    await toggleSafeSearch();
}

function hideSafeSearchNotification() {
    $(safeSearchNotificationContainerSelector).addClass('_hidden');
}

function closeEventsBanner() {
    $(eventsAnnouncementBannerSelector).remove();
    PMW.setCacheItem('user_has_closed_event_banner', '1');
}

function closeAIChatBanner() {
    $(aiChatBannerSelector).remove();
    PMW.setCacheItem(USER_HAS_CLOSED_AI_CHAT_BANNER_CACHE_KEY, '1');
}

function initEventsBanner() {
    $(function () {
        if (PMW.util.isInGalleryDialog()) {
            $(eventsAnnouncementBannerSelector).remove();
            return;
        }

        if (PMW.getCacheItem('user_has_closed_event_banner') === '1') {
            closeEventsBanner();
        }
    });
}

function toggleAIChatBannerVisibility() {
    $(function () {
      if (PMW.util.isInGalleryDialog() || isGalleryMarketingBannerVisible()) {
          $(aiChatBannerSelector).remove();
          return;
      }

      if (PMW.getCacheItem(USER_HAS_CLOSED_AI_CHAT_BANNER_CACHE_KEY) === '1') {
          closeAIChatBanner();
          return;
      }

        $(aiChatBannerSelector).addClass('-show');
    });
}

function onClickCreateEventButton() {
    const source = $(this).closest(eventsAnnouncementBannerSelector).attr('data-banner-source');
    PMW.gtm.trackGA4CustomEvent('Events_Create_Banner_Click', {source});
    PMW.gtm.trackGA4CustomEvent('Events_Create_Click');
    window.open(PMW.util.site_url('event/wizard'));
}

function onClickAIChatCTA() {
    const source = $(this).closest(aiChatBannerSelector).attr('data-banner-source');
    PMW.gtm.trackGA4CustomEvent(GALLEY_AI_CHAT_BANNER_CLICK_GA4_EVENT, {source});
    window.open(PMW.util.site_url('ai/chat'));
}

function hideGalleryMarketingBanner() {
    $('html').removeClass('show-gallery-marketing-banner');
}

/**
 *
 * @return {boolean}
 */
function isGalleryMarketingBannerVisible() {
    return $('html').hasClass('show-gallery-marketing-banner');
}

/**
 * @param {boolean} isLoading
 */
function toggleLoadingState(isLoading) {
    pageGrid.toggleClass('-loading', isLoading);
    pageGrid.css('pointer-events', isLoading ? 'none' : 'inherit');
    PMW.loading = isLoading; // prevent lazy loading
    PMW.posterGallery.posterGalleryFilters.setLoadingState(isLoading);
    $(document.body).css('overflow', isLoading ? 'hidden' : '');
    updateMobileFiltersIcon(isLoading);
    closeSubsizesListOnRedirect();
    $('.js-poster-types').addClass('_hidden'); // hide the matching sizes dropdown
}

function closeSubsizesListOnRedirect() {
    if (PMW.posterGallery.wasRequestRedirected) {
        PMW.onClickSubsizesCloseButton();
    }
}

/**
 * If the safe search filter is updated in the new url (due to automatically toggling based on search terms),
 * we update the current safe search filter to match it
 * We also ensure that the window history matches the updated safe search filter
 */
function updateSafeSearchFilterFromUrl() {
    const safeSearchFilterFromUrl = SafeSearchFilter.fromUrl(window.location.href);
    PMW.posterGallery.posterGalleryFilters.safeSearchFilter.handleUpdatedFilter(safeSearchFilterFromUrl);
    PMW.posterGallery.posterGalleryFilters.safeSearchFilter.previousActiveState = safeSearchFilterFromUrl.isFilterActive();
    window.history.replaceState(PMW.posterGallery.posterGalleryFilters.getPopStateObj(), '', window.location.href);
}

/**
 * @param {boolean} isLoading
 */
function updateMobileFiltersIcon(isLoading) {
    const filtersToggle = $('.js-toggle-gallery-filters.-phone'),
        isSearchLoading = PMW.posterGallery.posterGalleryFilters.searchTermFilter.isLoadingState();
    filtersToggle.toggleClass('-filters-loading', isLoading && !isSearchLoading);
    filtersToggle.toggleClass('-filters-disabled', isLoading);
}

function onGalleryFilterChange(e) {
    let updatedUrl = PMW.posterGallery.isMobileModalOpen
        ? PMW.posterGallery.urlForMobileModal
        : window.location.href;

    let filterToUpdate = null;
    const posterGalleryFilters = PMW.posterGallery.getPosterGalleryFiltersForUpdate();

    switch (e.detail.type) {
        case AdvancedFilter.advancedFiltersKey:
            filterToUpdate = posterGalleryFilters.advancedFilters.get(
                e.detail.advancedFiltersArrayKey
            );
            break;
        case DisplaySizeFilter.filterType:
            filterToUpdate = posterGalleryFilters.displaySizeFilter;
            break;
        case SearchTerm.filterType:
            filterToUpdate = posterGalleryFilters.searchTermFilter;
            break;
        case SafeSearchFilter.filterType:
            filterToUpdate = posterGalleryFilters.safeSearchFilter;
            break;
    }

    if (!filterToUpdate) return;

    updateFilterFromEvent(filterToUpdate, e);
    updatedUrl = filterToUpdate.updateUrl(updatedUrl);

    if (PMW.posterGallery.isMobileModalOpen) {
        PMW.posterGallery.urlForMobileModal = updatedUrl;

        if (!e.detail.isClickManuallyTriggered) {
            returnToMobileModalMainPanel();
        }
        return;
    }

    setTimeout(() => {
        document.dispatchEvent(
            new CustomEvent(EVENT_REFRESH_POSTER_GRID, {
                detail: {
                    redirectUrl: updatedUrl,
                    isRefreshThroughHistoryAPI: false,
                }
            })
        );
    }, 0);
}


/**
 * @param {AdvancedFilter|SafeSearchFilter|DisplaySizeFilter|SearchTerm} filterToUpdate
 * @param {CustomEvent} e
 */
function updateFilterFromEvent(filterToUpdate, e) {
    filterToUpdate.handleUpdatedFilter(e.detail.filter);
}

/**
 * If we lazy load a lot of templates, then the loading state
 * eats up a lot of processing power, making the page slow
 *
 * So we scroll to the top, show the top 50 as loading, and remove the rest
 * to reduce cpu usage.
 */
function removeUnnecessaryThumbnails() {
    PMW.util.smoothScrollTo($('#nav'));
    const templateThumbnails = $('.js-gallery-thumbnail'),
        lastThumbnailToKeep = templateThumbnails[50];

    if (typeof lastThumbnailToKeep !== 'undefined') {
        $(lastThumbnailToKeep).nextAll().remove();
    }
}

/**
 * @param {CustomEvent} e
 * @return {Promise<void>}
 */
async function onTemplateGalleryRefresh(e) {
    removeUnnecessaryThumbnails();
    hideSafeSearchNotification();
    hideGalleryMarketingBanner();
    toggleLoadingState(true);
    PMW.posterGallery.wasRequestRedirected = false;
    const htmlResponse = await getTemplatesForNewUrl(e);

    if (htmlResponse === '') {
        console.log('error in fetching');
        return;
    }
    updateGallerySections(htmlResponse);
    updateDisplaySizeFilterFromNewHtml(htmlResponse);
    PMW.util.removeCustomDesignCtaInAiChatGalleryDialog();
    initGalleryHandlers();
    updateEmbeddedUrls();
    toggleLoadingState(false);
    readjustSidebar();
    updateSafeSearchFilterFromUrl();
    void initBannerForSafeSearchException();
    doGa4Tracking();

    document.dispatchEvent(new CustomEvent(EVENT_UPDATE_SEARCH_FIELD));
}

/**
 * @param safeSearchPreference
 * @return {Promise<*>}
 */
function recordUserSafeSearchPreference(safeSearchPreference) {
    const preference = safeSearchPreference ? 1 : 0;

    if (PMW.isUserLoggedIn()) {
        return PMW.writeLocal('user/updateUserSafeSearchPreference', {preference});
    }
    return null;
}

/**
 * @param {boolean} safeSearchPreference
 */
function setUserSafeSearchPreferenceCookie(safeSearchPreference) {
    const preference = safeSearchPreference ? 1 : 0,
        safeSearchPreferenceCookieExpiryInDays = 14;
    PMW.util.setCookie(SAFE_SEARCH_PREFERENCE_COOKIE, preference, safeSearchPreferenceCookieExpiryInDays);
}

/**
 * Display sizes are difficult to parse from the url, so we let the html
 * be the source of truth for the current chosen display size
 *
 * @param {string} htmlResponse
 */
function updateDisplaySizeFilterFromNewHtml(htmlResponse) {
    const displaySizeFilterInNewHtml = DisplaySizeFilter.fromPageHtml(htmlResponse);
    PMW.posterGallery.posterGalleryFilters.displaySizeFilter.handleUpdatedFilter(displaySizeFilterInNewHtml);
}

/**
 * the gallery toggle button needs its links to be updated when new HTML is loaded in
 * @param {jQuery} htmlResponse
 */
function updateGalleryToggleFromNewHtml(htmlResponse) {
    const newToggle = htmlResponse.find('.js-gallery-type-toggle');
    galleryToggle.find(emailGalleryToggleSelector).attr('href', newToggle.find(emailGalleryToggleSelector).attr('href'));
}

function doGa4Tracking() {
    doGa4TrackingForNoSearchResults();
    trackGa4Search();
    // trackDisplaySize();
    // trackContentType();
    // trackColor();
    // trackMotion();
    // trackOrientation();
    // trackCategory();
    // trackSubcategory();
}

function doGa4TrackingForNoSearchResults() {
    if (!PMW.posterGallery.isSearchPage() || PMW.posterGallery.posterGalleryFilters.getCountOfActiveAdvancedFiltersWithoutContentType() > 0) {
        return;
    }
    const searchTerm = PMW.posterGallery.posterGalleryFilters.searchTermFilter.searchTerm,
        numTemplates = $('.js-gallery-thumbnail').length;

    if (searchTerm === '') {
        return;
    }

    if (numTemplates <= 0) {
        PMW.gtm.trackGA4CustomEvent(DESIGN_GALLERY_NO_SEARCH_RESULTS_EVENT_NAME, {searchTerm});
    }
}

function trackGa4Search() {
    if (!PMW.posterGallery.isSearchPage() || PMW.posterGallery.posterGalleryFilters.getCountOfActiveAdvancedFiltersWithoutContentType() > 0) {
        return;
    }
    const numResultsForNeedMoreTemplates = $('.js-gallery-thumbnail').length,
        searchTerm = PMW.posterGallery.posterGalleryFilters.searchTermFilter.searchTerm;

    if (searchTerm === '') {
        return;
    }
    PMW.gtm.trackGA4Search(searchTerm, PMW.gtm.GA4_CUSTOM_SEARCH_DEFINITION.DESIGN_GALLERY, numResultsForNeedMoreTemplates, PMW.needMoreTemplatesForSearchTerm);
}

function trackDisplaySize() {
    const displaySize = PMW.posterGallery.posterGalleryFilters.displaySizeFilter.displaySize;
    trackDesignGalleryEvent(PMW.gtm.GA4_CUSTOM_SEARCH_DEFINITION.DESIGN_GALLERY_FILTERS.DISPLAY_SIZE, {'size_type': displaySize});
}

function trackContentType() {
    const contentType = PMW.posterGallery.posterGalleryFilters.getContentTypeFilter().filterOption;
    trackDesignGalleryEvent(PMW.gtm.GA4_CUSTOM_SEARCH_DEFINITION.DESIGN_GALLERY_FILTERS.CONTENT_TYPE, {'filterType': contentType});
}

function trackColor() {
    const colorFilter = PMW.posterGallery.posterGalleryFilters.getColorFilter().filterOption;
    trackDesignGalleryEvent(PMW.gtm.GA4_CUSTOM_SEARCH_DEFINITION.DESIGN_GALLERY_FILTERS.COLOR, {'color_code': colorFilter});
}

function trackMotion() {
    const motionFilter = PMW.posterGallery.posterGalleryFilters.getMotionFilter().filterOption;
    trackDesignGalleryEvent(PMW.gtm.GA4_CUSTOM_SEARCH_DEFINITION.DESIGN_GALLERY_FILTERS.MOTION, {'filterMotion': motionFilter});
}

function trackOrientation() {
    const orientationFilter = PMW.posterGallery.posterGalleryFilters.getOrientationFilter().filterOption;
    trackDesignGalleryEvent(PMW.gtm.GA4_CUSTOM_SEARCH_DEFINITION.DESIGN_GALLERY_FILTERS.ORIENTATION, {'orientationType': orientationFilter});
}

function trackCategory() {
    if (!PMW.posterGallery.isCategoryPage()) {
        return;
    }
    const categoryUri = PMW.util.getMethodFromUrl(window.location.href);
    trackDesignGalleryEvent(PMW.gtm.GA4_CUSTOM_SEARCH_DEFINITION.DESIGN_GALLERY_FILTERS.CATEGORY, {'category_type': categoryUri});
}

function trackSubcategory() {
    if (!PMW.posterGallery.isSubcategoryPage()) {
        return;
    }
    const subcategoryUri = PMW.util.getMethodFromUrl(window.location.href);
    trackDesignGalleryEvent(PMW.gtm.GA4_CUSTOM_SEARCH_DEFINITION.DESIGN_GALLERY_FILTERS.SUBCATEGORY, {'sub-category_type': subcategoryUri});
}

/**
 * @param {string} eventName
 * @param {Object} params
 */
function trackDesignGalleryEvent(eventName, params) {
    PMW.gtm.trackGA4CustomEvent(PMW.gtm.GA4_DESIGN_GALLERY_FILTERS_PREFIX + eventName, params);
}

/**
 * @return {jQuery}
 */
function getGridMasonry() {
    return galleryContentContainer.find(visibleGridMasonrySelector);
}

/**
 * @param {string} htmlResponse
 */
function updateGallerySections(htmlResponse) {
    const
        /**
         * @var {jQuery}
         */
        htmlResponseJquery = $(htmlResponse),
        suggestedCategoriesContainerSelector = '.parent-category-search-results-list';

    updateBreadcrumbs(htmlResponseJquery);
    updatePageSeo(htmlResponseJquery);
    $(suggestedCategoriesContainerSelector).replaceWith(htmlResponseJquery.find(suggestedCategoriesContainerSelector));
    updatePageGrid(htmlResponseJquery);
    updateGalleryToggleFromNewHtml(htmlResponseJquery);
    updateHalloweenAnimationFromNewHtml(htmlResponseJquery);
    updateAIChatBannerFromNewHtml(htmlResponseJquery);
    addCssFromHTMLResponseToPage(htmlResponseJquery);
}

/**
 * @param {jQuery} htmlResponseJquery
 */
function updateEventsBannerFromNewHtml(htmlResponseJquery) {
    const currentEventsBanner = $(eventsAnnouncementBannerSelector);

    if (currentEventsBanner.length === 0) {
        return;
    }
    currentEventsBanner.remove();
    galleryContentContainer.prepend(htmlResponseJquery.find(eventsAnnouncementBannerSelector));
    initEventsBanner();
}

function updateAIChatBannerFromNewHtml(htmlResponseJquery) {
    const currentAIChatBanner = $(aiChatBannerSelector);

    if (currentAIChatBanner.length === 0) {
        return;
    }

    currentAIChatBanner.remove();
    galleryContentContainer.prepend(htmlResponseJquery.find(aiChatBannerSelector));
    toggleAIChatBannerVisibility();
}

/**
 *
 * @param {jQuery} htmlResponseJquery
 */
function updateHalloweenAnimationFromNewHtml(htmlResponseJquery) {
    const isHalloweenPage = htmlResponseJquery.find('.js-gallery-page-info').attr('data-is-halloween-page');
    $('.js-gallery-page-info').attr('data-is-halloween-page', Number(isHalloweenPage));
    PMW.unifiedGallery.addHalloweenGalleryPageClassToHtml();
}

/**
 *
 * @param {jQuery} htmlResponse
 */
function addCssFromHTMLResponseToPage(htmlResponse) {
    const cssLinks = htmlResponse.filter('link[rel="stylesheet"]');

    cssLinks.each(function () {
        const href = $(this).attr('href');

        if (!isCssFileAlreadyInPage(href)) {
            $('head').append($(this).clone());
        }
    });
}

/**
 * @param {jQuery} htmlResponseJquery
 */
function updateBreadcrumbs(htmlResponseJquery) {
    const breadcrumbsSelector = '#bcrumbs .breadcrumbs',
        mobileBreadcrumbsSelector = '#mobilecrumbs .breadcrumbs';
    $(breadcrumbsSelector).html(htmlResponseJquery.find(breadcrumbsSelector).html());
    $(mobileBreadcrumbsSelector).html(htmlResponseJquery.find(mobileBreadcrumbsSelector).html());
}

/**
 * @param {jQuery} htmlResponseJquery
 */
function updatePageSeo(htmlResponseJquery) {
    const seoHeadingSelector = '.js-seo-title',
        seoSubtitleSelector = '.js-seo-subtitle',
        htmlResponseSeoHeading = htmlResponseJquery.find(seoHeadingSelector),
        currentPageSeoHeading = $(seoHeadingSelector),
        newDocumentSeoTitle = htmlResponseSeoHeading.attr('data-page-title'),
        newDocumentMetaDescription = htmlResponseJquery.filter('meta[name=description]').attr('content'),
        currentPageMetaDescEl = $('meta[name=description]');
    currentPageSeoHeading.text(htmlResponseSeoHeading.text());
    currentPageSeoHeading.attr('data-page-title', newDocumentSeoTitle);

    const cleanedTitle = PMW.util.escapeHTML(newDocumentSeoTitle?.replace('&quot;', '"') ?? '');
    document.title = $(`<div>${cleanedTitle}</div>`).html();
    currentPageMetaDescEl.attr('content', newDocumentMetaDescription);
    $(seoSubtitleSelector).text(htmlResponseJquery.find(seoSubtitleSelector).text());
}

/**
 * If the user has subsizes open, replacing the current sidebar will cause it to close
 * when loading. So we update all state for the current sidebar using the new one
 *
 * @param {jQuery} htmlResponseJquery
 */
function updatePageGrid(htmlResponseJquery) {
    updateSizeListUrls(htmlResponseJquery);
    updateSearchMetaForSearchLandingpageVariant(htmlResponseJquery);

    const pageGridSelector = '.js-page-grid';

    if ($('.js-landingpage-variant').length > 0) {
        pageGrid.addClass('-landingpage-variant');
    }
    toggleAllSizeOptionVisibility();
    updateSubfilterCarousel(htmlResponseJquery);
    getGridMasonry().replaceWith(htmlResponseJquery.find(gridMasonrySelector));
    pageGrid.attr('data-url', htmlResponseJquery.find(pageGridSelector).attr('data-url'));

    if (isEmptyState()) {
        initEmptyState();
    }
}

/**
 * @param {jQuery} htmlResponseJquery
 */
function updateSubfilterCarousel(htmlResponseJquery) {
    const currentSubfilterCarousel = galleryContentContainer.find(subfilterCarouselSelector),
        newSubfilterCarousel = htmlResponseJquery.find(subfilterCarouselSelector),
        currentCarouselType = currentSubfilterCarousel.attr('data-carousel-type'),
        newCarouselType = newSubfilterCarousel.attr('data-carousel-type');
    galleryContentContainer.toggleClass('-has-subcategories-carousel', newSubfilterCarousel.length > 0);

    if (currentCarouselType !== newCarouselType) {
        addNewCarouselToHtml(currentSubfilterCarousel, newSubfilterCarousel);
        return;
    }

    if (currentCarouselType === SUBCATEGORY_CAROUSEL_TYPE) {
        updateActiveItemForSubcategoryCarousel(currentSubfilterCarousel, newSubfilterCarousel);
        updateUrlsForSubcategoryCarousel(currentSubfilterCarousel, newSubfilterCarousel);
    }
}

/**
 * @param {jQuery} currentSubfilterCarousel
 * @param {jQuery} newSubfilterCarousel
 */
function addNewCarouselToHtml(currentSubfilterCarousel, newSubfilterCarousel) {
    if (newSubfilterCarousel.length === 0) {
        currentSubfilterCarousel.remove();
        return;
    }

    if (currentSubfilterCarousel.length === 0) {
        galleryContentContainer.prepend(newSubfilterCarousel);
        return;
    }
    currentSubfilterCarousel.replaceWith(newSubfilterCarousel);
}

/**
 * Manually update the selected item for subcategory carousels
 *
 * @param {jQuery} currentSubfilterCarousel
 * @param {jQuery} newSubfilterCarousel
 */
function updateActiveItemForSubcategoryCarousel(currentSubfilterCarousel, newSubfilterCarousel) {
    const selectedSubcatUri = newSubfilterCarousel.find('.js-active-subfilter-item').attr('data-subcategory-uri');
    currentSubfilterCarousel.find('.js-subcategory-preview-item').removeClass('-active -loading -disabled js-active-subfilter-item');
    currentSubfilterCarousel.find(`.js-subcategory-preview-item[data-subcategory-uri=${selectedSubcatUri}]`).addClass('-active js-active-subfilter-item');
}

/**
 * Manually update the selected item for subcategory carousels
 *
 * @param {jQuery} currentSubfilterCarousel
 * @param {jQuery} newSubfilterCarousel
 */
function updateUrlsForSubcategoryCarousel(currentSubfilterCarousel, newSubfilterCarousel) {
    const currentPreviews = currentSubfilterCarousel.find('.js-subcategory-preview-item');

    currentPreviews.each(function () {
        const currentPreview = $(this),
            subcategoryUri = currentPreview.attr('data-subcategory-uri'),
            matchingPreviewInNewCarousel = newSubfilterCarousel.find(`.js-subcategory-preview-item[data-subcategory-uri=${subcategoryUri}]`);

        if (matchingPreviewInNewCarousel.length === 0) {
            return;
        }
        const currentPreviewLinkEl = currentPreview.find('.js-subcategory-link'),
            newPreviewLinkEl = matchingPreviewInNewCarousel.find('.js-subcategory-link');
        currentPreviewLinkEl.attr('href', newPreviewLinkEl.attr('href'));
    });
}

function initEmptyState() {
    attachClickHandlerForClearingFilters();
    attachClickHandlerForUpdatingSearchTerm();
    handleWrappingTextInEmptyState();
    resetOpacityForEmptyState();
}

function attachClickHandlerForUpdatingSearchTerm() {
    const updateSearchTermCta = $('.js-update-search-term'),
        searchField = document.querySelector('.js-search-field-input');
    PMW.onClick(updateSearchTermCta, null, function () {
        searchField.focus();
        searchField.select();
    });
}

function resetOpacityForEmptyState() {
    $(emptyStateContainerSelector).removeClass('_opacity-0');
}

function handleWrappingTextInEmptyState() {
    const emptyStateTextContainers = document.querySelectorAll('.js-empty-state-text-container');
    let emptyStateTextNodes = [];

    emptyStateTextContainers.forEach(textNode => emptyStateTextNodes.push(textNode.firstChild));
    const isTextWrapping = emptyStateTextNodes.some(textNode => isTextContentWrapping(textNode));

    $(emptyStateContainerSelector).toggleClass('-for-mobile', isTextWrapping);
}

/**
 * @param {ChildNode} textNode
 * @return {boolean}
 * @see https://www.bennadel.com/blog/4310-detecting-rendered-line-breaks-in-a-text-node-in-javascript.htm
 */
function isTextContentWrapping(textNode) {
    const range = document.createRange();
    range.setStart(textNode, 0);
    range.setEnd(textNode, textNode.textContent.length);
    return range.getClientRects().length > 1;
}

/**
 * @param {boolean} isFlyoutVisible
 */
function updateSafeSearchNotificationText(isFlyoutVisible) {
    const mobileSafeSearchNotifTextSelector = '.js-mobile-safe-search-notif-text',
        mobileSafeSearchNotifLongText = $(`${mobileSafeSearchNotifTextSelector}.-long-text`),
        mobileSafeSearchNotifShortText = $(`${mobileSafeSearchNotifTextSelector}.-short-text`);
    mobileSafeSearchNotifLongText.toggleClass('_hidden', isFlyoutVisible);
    mobileSafeSearchNotifShortText.toggleClass('_hidden', !isFlyoutVisible);
}

function attachClickHandlerForClearingFilters() {
    const posterGalleryFilters = PMW.posterGallery.getPosterGalleryFiltersForUpdate(),
        canRemoveFilters = (!PMW.posterGallery.isSizesPage() && posterGalleryFilters.displaySizeFilter.isFilterActive()) || (posterGalleryFilters.getCountOfActiveAdvancedFilters() > 0),
        removeFiltersCta = $('.js-remove-some-filters');

    if (!canRemoveFilters) {
        removeFiltersCta.addClass('-disabled-tip');
        return;
    }
    PMW.onClick(removeFiltersCta, null, function () {
        const toggleFiltersButton = $(`${toggleFiltersButtonSelector}:visible`);

        if (!toggleFiltersButton.hasClass('-active')) {
            toggleFiltersButton.first().trigger(PMW.click);
        }
    });
}

/**
 * @return {boolean}
 */
function isEmptyState() {
    return $(emptyStateContainerSelector).length > 0;
}

function toggleAllSizeOptionVisibility() {
    $(`.js-size-filter[data-size-name=${DisplaySizeFilter.allFilterOption}]`).toggleClass('_hidden', PMW.util.getControllerFromUrl(window.location.href) === 'sizes');
}

/**
 * @param {jQuery} htmlResponseJquery
 */
function updateSearchMetaForSearchLandingpageVariant(htmlResponseJquery) {
    const searchMetaSelector = '.js-search-meta';

    if (pageGrid.find(searchMetaSelector).length === 0) {
        return;
    }
    pageGrid.find(searchMetaSelector).insertAfter(htmlResponseJquery.find('.js-sizes-sidebar'));
}

/**
 * @param {jQuery} htmlResponseJquery
 */
function updateSizeListUrls(htmlResponseJquery) {
    const allDisplaySizesSelector = '.js-sizes-sidebar .js-size-filter',
        allDisplaySizes = $(allDisplaySizesSelector);

    allDisplaySizes.each(function () {
        /**
         * @var {jQuery}
         */
        const displaySize = $(this),
            displaySizeInNewHtml = htmlResponseJquery.find(`${allDisplaySizesSelector}[data-size-name=${displaySize.attr('data-size-name')}]`);

        if (displaySizeInNewHtml.length === 0) {
            return;
        }
        displaySize.find('.js-size-href').attr('href', displaySizeInNewHtml.find('.js-size-href').attr('href'));
    });
}

/**
 * @param {CustomEvent} e
 * @return {Promise<string>}
 */
async function getTemplatesForNewUrl(e) {
    let html,
        url = PMW.util.addEmbeddedParamsToUrl(e.detail.redirectUrl),
        newUrl = url,
        ajaxUrl = PMW.posterGallery.posterGalleryFilters.removeSafeSearchFilterFromUrlIfNeeded(url);

    /**
     * If we get a 4xx header in our ajax request (maybe due to a bad search), jquery will throw an error.
     * So we use this function to handle the ajax response in both success and (soft) failure cases
     * @param {string} htmlResponse
     */
    function handleGalleryAjaxResponse(htmlResponse) {
        /**
         * @var {jQuery}
         */
        const htmlResponseJquery = $(htmlResponse),
            designGalleryPageGridInResponse = htmlResponseJquery.find('.js-design-gallery-page-grid');

        if (designGalleryPageGridInResponse.length === 0) {
            // if we're redirected to a page that isn't a design gallery page, we update the url and hit it directly so that
            // we are properly redirected
            window.history.pushState('', '', ajaxUrl);
            window.location.reload();
            html = '';
            return;
        }
        html = htmlResponse;
        newUrl = designGalleryPageGridInResponse.attr('data-url');
        PMW.posterGallery.wasRequestRedirected = wasRequestRedirected(url, newUrl);
        updateWindowHistory(e, url, newUrl);
    }

    try {
        await PMW.getRequestAtUrl(ajaxUrl, {}, undefined, undefined)
            .done((htmlResponse) => handleGalleryAjaxResponse(htmlResponse))
            .fail((responseObj) => handleGalleryAjaxResponse(responseObj.responseText));
    } catch (e) {
        // ignore the error
    }
    return html;
}

/**
 * @param {CustomEvent} e
 * @param {string} url
 * @param {string} newUrl
 */
function updateWindowHistory(e, url, newUrl) {
    if (PMW.util.ignoreWindowHistoryUpdateForSubdomain(newUrl)) {
        window.location.href = newUrl;
        return;
    }

    if (!e.detail.isRefreshThroughHistoryAPI) {
        window.history.pushState(
            PMW.posterGallery.posterGalleryFilters.getPopStateObj(),
            '',
            PMW.posterGallery.wasRequestRedirected ? newUrl : url
        );
    } else {
        window.history.replaceState(
            PMW.posterGallery.posterGalleryFilters.getPopStateObj(),
            '',
            PMW.posterGallery.wasRequestRedirected ? newUrl : url
        );
    }
}

/**
 * If the ajax was redirected, the urls will be different.
 *
 * @param {string} url
 * @param {string} newUrl
 * @return {boolean}
 */
function wasRequestRedirected(url, newUrl) {
    return doUrlsHaveDifferentSafeSearchParams(url, newUrl) || doUrlsHaveDifferentPaths(url, newUrl);
}

/**
 * Some urls have a trailing slash, while php's current_full_url does not give a trailing slash
 * So we remove the trailing slash before comparing the urls.
 *
 * @param {string} url
 * @param {string} newUrl
 * @return {boolean}
 */
function doUrlsHaveDifferentPaths(url, newUrl) {
    return getUrlPathnameWithoutTrailingSlash(url) !== getUrlPathnameWithoutTrailingSlash(newUrl);
}

/**
 * @param {string} url
 * @param {string} newUrl
 * @return {boolean}
 */
function doUrlsHaveDifferentSafeSearchParams(url, newUrl) {
    return SafeSearchFilter.fromUrl(url).isFilterActive() !== SafeSearchFilter.fromUrl(newUrl).isFilterActive();
}

function getUrlPathnameWithoutTrailingSlash(url) {
    const urlObj = new URL(url),
        pathname = urlObj.pathname;

    if (pathname.slice(-1) !== '/') {
        return pathname;
    }
    return pathname.slice(0, -1);
}

function readjustSidebar() {
    PMW.unifiedGallery.adjustSidebarVerticalMeasurements();
    toggleSidebarWidth();
}

function handleModalOpeningInsideGalleryDialog() {
    if (PMW.util.isInGalleryDialog()) {
        PMW.util.hideGalleryDialogHeaderFromWithinIFrame();
    }
}

function handleModalClosingInsideGalleryDialog() {
    if (PMW.util.isInGalleryDialog()) {
        PMW.util.showGalleryDialogHeaderFromWithinIFrame();
    }
}

function closeFiltersDialog() {
    PMW.closeModalDialog(ID_MOBILE_FILTER_DIALOG);
    handleModalClosingInsideGalleryDialog();
}

function isCssFileAlreadyInPage(href) {
    return $('link[rel="stylesheet"][href="' + href + '"]').length > 0;
}